export const MARKET_PLACE = [
    {
        name: 'UNITED_STATES',
        id: 'UNITED_STATES',
        url: 'https://www.amazon.com/',
        domain: 'com',
        postCode: '10036',
        countryCode: 'US',
        currencyCode: 'USD',
        marketPlaceId: 'ATVPDKIKX0DER',
        region: 'Americas',
    },
    {
        name: 'BRAZIL',
        id: 'BRAZIL',
        url: 'https://www.amazon.com.br/',
        domain: 'com.br',
        postCode: '69475 000',
        countryCode: 'BR',
        currencyCode: 'BRL',
        marketPlaceId: 'A2Q3Y263D00KWC',
        region: 'Americas',
    },
    {
        name: 'CANADA',
        id: 'CANADA',
        url: 'https://www.amazon.ca/',
        domain: 'ca',
        postCode: 'K1A 0A0',
        countryCode: 'CA',
        currencyCode: 'CAD',
        marketPlaceId: 'A2EUQ1WTGCTBG2',
        region: 'Americas',
    },
    {
        name: 'MEXICO',
        id: 'MEXICO',
        url: 'https://www.amazon.com.mx/',
        domain: 'com.mx',
        postCode: '11000',
        countryCode: 'MX',
        currencyCode: 'MXN',
        marketPlaceId: 'A1AM78C64UM0Y8',
        region: 'Americas',
    },
    {
        name: 'AUSTRALIA',
        id: 'AUSTRALIA',
        url: 'https://www.amazon.com.au/',
        domain: 'com.au',
        postCode: '2000',
        countryCode: 'AU',
        currencyCode: 'AUD',
        marketPlaceId: 'A39IBJ37TRP1C6',
        region: 'Oceania',
    },
    {
        name: 'JAPAN',
        id: 'JAPAN',
        url: 'https://www.amazon.co.jp/',
        domain: 'co.jp',
        postCode: '059 0005',
        countryCode: 'JP',
        currencyCode: 'JPY',
        marketPlaceId: 'A1VC38T7YXB528',
        region: 'Asia-Pacific',
    },
    {
        name: 'INDIA',
        id: 'INDIA',
        url: 'https://www.amazon.in/',
        domain: 'in',
        postCode: '400001',
        countryCode: 'IN',
        currencyCode: 'INR',
        marketPlaceId: 'A21TJRUUN4KGV',
        region: 'Asia-Pacific',
    },
    {
        name: 'SINGAPORE',
        id: 'SINGAPORE',
        url: 'https://www.amazon.sg/',
        domain: 'sg',
        postCode: '470101',
        countryCode: 'SG',
        currencyCode: 'SGD',
        marketPlaceId: 'A19VAU5U5O7RUS',
        region: 'Asia-Pacific',
    },
    {
        name: 'GERMANY',
        id: 'GERMANY',
        url: 'https://www.amazon.de/',
        domain: 'de',
        postCode: '10245',
        countryCode: 'DE',
        currencyCode: 'EUR',
        marketPlaceId: 'A1PA6795UKMFR9',
        region: 'Europe',
    },
    {
        name: 'SPAIN',
        id: 'SPAIN',
        url: 'https://www.amazon.es/',
        domain: 'es',
        postCode: '28001',
        countryCode: 'ES',
        currencyCode: 'EUR',
        marketPlaceId: 'A1RKKUPIHCS9HS',
        region: 'Europe',
    },
    {
        name: 'FRANCE',
        id: 'FRANCE',
        url: 'https://www.amazon.fr/',
        domain: 'fr',
        postCode: '75010',
        countryCode: 'FR',
        currencyCode: 'EUR',
        marketPlaceId: 'A13V1IB3VIYZZH',
        region: 'Europe',
    },
    {
        name: 'ITALY',
        id: 'ITALY',
        url: 'https://www.amazon.it/',
        domain: 'it',
        postCode: '00145',
        countryCode: 'IT',
        currencyCode: 'EUR',
        marketPlaceId: 'APJ6JRA9NG5V4',
        region: 'Europe',
    },
    {
        name: 'NETHERLANDS',
        id: 'NETHERLANDS',
        url: 'https://www.amazon.nl/',
        domain: 'nl',
        postCode: '1079',
        countryCode: 'NL',
        currencyCode: 'EUR',
        marketPlaceId: 'A1805IZSGTT6HS',
        region: 'Europe',
    },
    {
        name: 'BELGIUM',
        id: 'BELGIUM',
        url: 'https://www.amazon.com.be/',
        domain: 'com.be',
        postCode: '1050',
        countryCode: 'BE',
        currencyCode: 'EUR',
        marketPlaceId: 'AMEN7PMS3EDWL',
        region: 'Europe',
    },
    {
        name: 'POLAND',
        id: 'POLAND',
        url: 'https://www.amazon.pl/',
        domain: 'pl',
        postCode: '10 001',
        countryCode: 'PL',
        currencyCode: 'PLN',
        marketPlaceId: 'A1C3SOZRARQ6R3',
        region: 'Europe',
    },
    {
        name: 'SWEDEN',
        id: 'SWEDEN',
        url: 'https://www.amazon.se/',
        domain: 'se',
        postCode: '111 22',
        countryCode: 'SE',
        currencyCode: 'SEK',
        marketPlaceId: 'A2NODRKZP88ZB9',
        region: 'Europe',
    },
    {
        name: 'UNITED_KINGDOM',
        id: 'UNITED_KINGDOM',
        url: 'https://www.amazon.co.uk/',
        domain: 'co.uk',
        postCode: 'NW10 0AA',
        countryCode: 'GB',
        currencyCode: 'GBP',
        marketPlaceId: 'A1F83G8C2ARO7P',
        region: 'Europe',
    },
    {
        name: 'IRELAND',
        id: 'IRELAND',
        url: 'https://www.amazon.ie/',
        domain: 'ie',
        postCode: 'D01 F5P2',
        countryCode: 'IE',
        currencyCode: 'EUR',
        marketPlaceId: 'A28R8C7NBKEWEA',
        region: 'Europe',
    },
    {
        name: 'UNITED_ARAB_EMIRATES',
        id: 'UNITED_ARAB_EMIRATES',
        url: 'https://www.amazon.ae/',
        domain: 'ae',
        postCode: '',
        countryCode: 'AE',
        currencyCode: 'AED',
        marketPlaceId: 'A2VIGQ35RCS4UG',
        region: 'Middle East',
    },
    {
        name: 'EGYPT',
        id: 'EGYPT',
        url: 'https://www.amazon.eg/',
        domain: 'eg',
        postCode: '',
        countryCode: 'EG',
        currencyCode: 'EGP',
        marketPlaceId: 'ARBP9OOSHTCHU',
        region: 'Middle East',
    },
    {
        name: 'SAUDI_ARABIA',
        id: 'SAUDI_ARABIA',
        url: 'https://www.amazon.sa/',
        domain: 'sa',
        postCode: '',
        countryCode: 'SA',
        currencyCode: 'SAR',
        marketPlaceId: 'A17E79C6D8DWNP',
        region: 'Middle East',
    },
];
